import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { Table, Container, Button, Form, Pagination, Row, Col, Modal, Alert } from 'react-bootstrap';
import * as XLSX from 'xlsx'; // Import thư viện xlsx

const StudentReception = () => {
    const [majors, setMajors] = useState([]);
    const [classes, setClasses] = useState([{ _id: '', name: 'Tất cả các lớp' }]);
    const [statusOptions] = useState(['Tạo mới', 'Đã xác nhận nhập học', 'Đã nộp tiền', 'Đã chia lớp', 'Đã nộp hồ sơ']);
    const [selectedMajor, setSelectedMajor] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [modalSelectedClass, setModalSelectedClass] = useState(''); // Sử dụng cho modal

    const [selectedStatus, setSelectedStatus] = useState('');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [enrollments, setEnrollments] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [currentAcademicYear, setCurrentAcademicYear] = useState('');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedEnrollment, setSelectedEnrollment] = useState(null);
    const [notes, setNotes] = useState('');
    const [error, setError] = useState('');
    const [classCounts, setClassCounts] = useState([]);


    const fetchClassCounts = async (academicYear) => {
        try {
            const res = await axios.get('/classes/classes-with-enrollment-count', {
                params: { academicYear }
            });
            setClassCounts(res.data);
        } catch (err) {
            console.error('Error fetching class counts', err);
        }
    };

    useEffect(() => {
        const fetchCurrentAcademicYear = async () => {
            try {
                const res = await axios.get('/configurations/key/current_academic_year');
                const academicYear = res.data.configValue;
                setCurrentAcademicYear(academicYear);

                // Sau khi lấy được currentAcademicYear, thực thi hai hàm này
                fetchClassCounts(academicYear);
                fetchMajors(academicYear);
            } catch (err) {
                console.error('Error fetching current academic year', err);
            }
        };

        /*const fetchClassCounts = async (academicYear) => {
            try {
                const res = await axios.get('/classes/classes-with-enrollment-count', {
                    params: { academicYear }
                });
                setClassCounts(res.data);
            } catch (err) {
                console.error('Error fetching class counts', err);
            }
        };*/

        const fetchMajors = async (academicYear) => {
            try {
                const res = await axios.get('/majors?academicYear=${academicYear}');
                setMajors([{ _id: '', name: 'Tất cả các ngành' }, ...res.data.majors]);
            } catch (err) {
                console.error('Error fetching majors', err);
            }
        };
        // Thực thi hàm để lấy currentAcademicYear trước tiên
        fetchCurrentAcademicYear();
    }, [currentAcademicYear]);

    const fetchClasses = async (majorId) => {
        if (!majorId) {
            setClasses([{ _id: '', className: 'Tất cả các lớp' }]);
            return;
        }
        try {
            const res = await axios.get(`/classes?majorId=${majorId}`);
            setClasses([{ _id: '', className: 'Tất cả các lớp' }, ...res.data]);
        } catch (err) {
            console.error('Error fetching classes', err);
        }
    };

    const fetchEnrollments = async (page = 1) => {
        try {
            const res = await axios.get('/student-reception/reception', {
                params: {
                    academicYear: currentAcademicYear,
                    majorId: selectedMajor,
                    classId: selectedClass,
                    status: selectedStatus,
                    search: searchKeyword,
                    page,
                },
            });
            setEnrollments(res.data.enrollments);
            setTotalPages(res.data.totalPages);
            setPage(res.data.currentPage);
        } catch (err) {
            console.error('Error fetching enrollments', err);
        }
    };

    const handleMajorChange = (e) => {
        setSelectedMajor(e.target.value);
        setSelectedClass('');
        fetchClasses(e.target.value);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchEnrollments(1);
    };

    const handlePageChange = (pageNumber) => {
        fetchEnrollments(pageNumber);
    };

    /*const handleShowDetailModal = (enrollment) => {
        setSelectedEnrollment(enrollment);
        setNotes(enrollment.notes || '');
        setShowDetailModal(true);
    };*/
    const handleShowDetailModal = (enrollment) => {
        console.log("handleShowDetailModal: ", enrollment); // Kiểm tra toàn bộ đối tượng enrollment
        setSelectedEnrollment(enrollment);
        setNotes(enrollment.notes || '');
        setModalSelectedClass(enrollment.class ? enrollment.class : ''); // Thiết lập giá trị ban đầu cho modal
        setShowDetailModal(true);
    };


    const handleCloseDetailModal = () => {
        setSelectedEnrollment(null);
        setShowDetailModal(false);
    };
    /*
    const handleSaveChanges = async () => {
        try {
            const updatedEnrollment = {
                ...selectedEnrollment,
                class: selectedClass || selectedEnrollment.class,
                status: selectedStatus || selectedEnrollment.status,
                notes,
            };

            await axios.put(`/enrollments/${selectedEnrollment._id}/details`, updatedEnrollment);
            fetchEnrollments(page);
            handleCloseDetailModal();
        } catch (err) {
            console.error('Failed to save enrollment details', err);
            setError('Failed to save enrollment details');
        }
    };*/
    const handleSaveChanges = async () => {
        try {
            const updatedEnrollment = {
                ...selectedEnrollment,
                class: modalSelectedClass || selectedEnrollment.class, // Sử dụng modalSelectedClass
                status: selectedStatus || selectedEnrollment.status,
                notes,
            };

            await axios.put(`/enrollments/${selectedEnrollment._id}/details`, updatedEnrollment);
            fetchClassCounts(currentAcademicYear);

            fetchEnrollments(page);
            handleCloseDetailModal();
        } catch (err) {
            console.error('Failed to save enrollment details', err);
            setError('Failed to save enrollment details');
        }
    };

    /*const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(enrollments.map((enrollment, index) => ({
            'Số thứ tự': (page - 1) * 20 + index + 1,
            'Mã sinh viên': enrollment.studentId,
            'Họ tên': enrollment.name,
            'Ngày sinh': new Date(enrollment.birthDate).toLocaleDateString(),
            'Số CCCD/CMND': enrollment.citizenId,
            'Mã vạch': enrollment.barcode,
            'Số GBNNH': enrollment.enrollmentReceiptNumber,
            'Tình trạng': enrollment.status
        })));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Enrollments');
        XLSX.writeFile(workbook, 'enrollments.xlsx');
    };*/
    const handleExportExcel = async () => {
        try {
            // Fetch tất cả dữ liệu enrollments (không phân trang) để xuất ra Excel
            const res = await axios.get('/student-reception/export', {
                params: {
                    academicYear: currentAcademicYear,
                    majorId: selectedMajor,
                    classId: selectedClass,
                    status: selectedStatus,
                    search: searchKeyword,
                },
            });

            const enrollments = res.data.enrollments;

            const data = enrollments.map((enrollment, index) => ({
                'Số thứ tự': index + 1,
                'Mã sinh viên': enrollment.studentId,
                'Họ tên': enrollment.name,
                'Ngày sinh': new Date(enrollment.birthDate).toLocaleDateString(),
                'Số CCCD/CMND': enrollment.citizenId,
                'Mã vạch': enrollment.barcode,
                'Số GBNNH': enrollment.enrollmentReceiptNumber,
                'Lớp': enrollment.class ? enrollment.class.className : '', // Kiểm tra nếu có lớp thì lấy className, không thì để trống
                'Ngành trúng tuyển': enrollment.majorName,
                'Mã ngành TT': enrollment.majorCode,
                'Ngày nhập học': new Date(enrollment.enrollmentDate).toLocaleDateString(),
                'PTXT': enrollment.admissionMethod,
                'Tên Tỉnh': enrollment.province,
                'Điện thoại': enrollment.phoneNumber,
                'Tình trạng': enrollment.status,
                'Ghi chú': enrollment.notes
            }));

            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Enrollments');
            XLSX.writeFile(workbook, 'enrollments.xlsx');
        } catch (err) {
            console.error('Error exporting to Excel', err);
        }
    };

    return (
        <Container>
            <h2>Đón tiếp sinh viên</h2>
            {/* Hiển thị danh sách lớp và số lượng sinh viên */}
            <Row>
                {classCounts.map((cls, index) => (
                    <Col key={index} md={2} className="mb-3">
                        <div className="text-center">
                            <strong>{cls.className}</strong>
                            <div>Số lượng / Max: {cls.count}/{cls.maxStudents}</div>
                        </div>
                    </Col>
                ))}
            </Row>
            <Form onSubmit={handleSearchSubmit} className="mb-3">
                <Row>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Ngành</Form.Label>
                            <Form.Control as="select" value={selectedMajor} onChange={handleMajorChange}>
                                {majors.map((major) => (
                                    <option key={major._id} value={major._id}>
                                        {major.majorName}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Lớp</Form.Label>
                            <Form.Control as="select" value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}>
                                {classes.map((cls) => (
                                    <option key={cls._id} value={cls._id}>
                                        {cls.className}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Tình trạng</Form.Label>
                            <Form.Control as="select" value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                                <option value="">Tất cả tình trạng</option>
                                {statusOptions.map((status, index) => (
                                    <option key={index} value={status}>
                                        {status}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Từ khóa</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Tìm theo mã SV, Số BD, CCCD, mã vạch"
                                value={searchKeyword}
                                onChange={(e) => setSearchKeyword(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Button variant="primary" type="submit">
                    Tìm kiếm
                </Button>
                <Button variant="success" className="ml-2" onClick={handleExportExcel}>
                    Xuất Excel
                </Button>
            </Form>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Số thứ tự</th>
                        <th>Mã sinh viên</th>
                        <th>Họ tên</th>
                        <th>Ngày sinh</th>
                        <th>Ngành trúng tuyển</th>
                        <th>Ngày nhập học</th>
                        <th>Điện thoại</th>
                        <th>Số CCCD/CMND</th>
                        <th>Mã vạch</th>
                        <th>Số GBNH</th>
                        <th>Tình trạng</th>
                    </tr>
                </thead>
                <tbody>
                    {enrollments.map((enrollment, index) => (
                        <tr key={enrollment._id} onClick={() => handleShowDetailModal(enrollment)}>
                            <td>{(page - 1) * 20 + index + 1}</td> {/* Số thứ tự */}
                            <td>{enrollment.studentId}</td>
                            <td>{enrollment.name}</td>
                            <td>{new Date(enrollment.birthDate).toLocaleDateString()}</td>
                            <td>{enrollment.majorName}</td>
                            <td>{new Date(enrollment.enrollmentDate).toLocaleDateString()}</td>
                            <td>{enrollment.phoneNumber}</td>
                            <td>{enrollment.citizenId}</td>
                            <td>{enrollment.barcode}</td>
                            <td>{enrollment.enrollmentReceiptNumber}</td>
                            <td>{enrollment.status}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Pagination>
                {[...Array(totalPages).keys()].map((number) => (
                    <Pagination.Item key={number + 1} active={number + 1 === page} onClick={() => handlePageChange(number + 1)}>
                        {number + 1}
                    </Pagination.Item>
                ))}
            </Pagination>

            {selectedEnrollment && (
                <EnrollmentDetailModal
                show={showDetailModal}
                onHide={handleCloseDetailModal}
                enrollment={selectedEnrollment}
                onSave={handleSaveChanges}
                classes={classes}
                selectedClass={modalSelectedClass} // Truyền modalSelectedClass vào modal
                setSelectedClass={setModalSelectedClass} // Truyền setModalSelectedClass vào modal
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                notes={notes}
                setNotes={setNotes}
                error={error}
                />
            )}
        </Container>
    );
};

const EnrollmentDetailModal = ({
    show,
    onHide,
    enrollment,
    onSave,
    selectedClass,
    setSelectedClass,
    selectedStatus,
    setSelectedStatus,
    notes,
    setNotes,
    error
}) => {
    const [classes, setClasses] = useState([]);

    useEffect(() => {
        const fetchClasses = async () => {
            if (enrollment && enrollment.majorCode) {
                try {
                    const res = await axios.get('/student-reception/classes-by-major-code', {
                        params: { majorCode: enrollment.majorCode }
                    });
                    setClasses([{ _id: '', className: 'Tất cả các lớp' }, ...res.data]);
                } catch (err) {
                    console.error('Error fetching classes by major code', err);
                }
            } else {
                setClasses([{ _id: '', className: 'Tất cả các lớp' }]);
            }
        };

        fetchClasses();
    }, [enrollment]);

    if (!enrollment) {
        return null;
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Chi tiết sinh viên</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form>
                    <Form.Group>
                        <Form.Label>Mã sinh viên</Form.Label>
                        <Form.Control type="text" value={enrollment.studentId} disabled />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Họ tên</Form.Label>
                        <Form.Control type="text" value={enrollment.name} disabled />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Lớp</Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedClass}
                            onChange={(e) => setSelectedClass(e.target.value)}
                        >
                            {classes.map((cls) => (
                                <option key={cls._id} value={cls._id}>
                                    {cls.className}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Tình trạng</Form.Label>
                        <Form.Control as="select" value={selectedStatus || enrollment.status} onChange={(e) => setSelectedStatus(e.target.value)}>
                            <option value="Tạo mới">Tạo mới</option>
                            <option value="Đã xác nhận nhập học">Đã xác nhận nhập học</option>
                            <option value="Đã nộp tiền">Đã nộp tiền</option>
                            <option value="Đã chia lớp">Đã chia lớp</option>
                            <option value="Đã nộp hồ sơ">Đã nộp hồ sơ</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Ghi chú</Form.Label>
                        <Form.Control as="textarea" rows={3} value={notes} onChange={(e) => setNotes(e.target.value)} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Đóng
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Lưu thay đổi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};



export default StudentReception;